// extracted by mini-css-extract-plugin
export default {"auth":"auth_auth__6j5R1","logo":"auth_logo__wsZIK","bgLayer":"auth_bgLayer__s5vXF"};